/**
 * The child half of the web SDK, for `routes/SdkScreen.tsx`: register the zoid
 * component on this page and hand back the parent's props. zoid is imported
 * here, on demand, so no other route ships it.
 */
import type { VerifyProps } from './component';

/** What the child needs from zoid: the parent's callback, or "not opened by the SDK". */
export type SdkParent = Pick<VerifyProps, 'onFlowEvent'> | null;

export async function loadSdkParent(): Promise<SdkParent> {
  const { verifyComponent } = await import('./component');
  const component = verifyComponent();
  return component.isChild() && component.xprops ? component.xprops : null;
}
